/** Ship-date flexibility choices (days either side), shared by the search forms. */
export const FLEXIBILITY_OPTIONS = [0, 1, 2, 3, 5, 7, 10, 14].map((days) => ({
  value: days,
  label: days === 0 ? 'Exact date' : `+/- ${days} days`,
}));
